import { Stack, TablePagination } from "@mui/material";
import { useMemo } from "react";
import { StyledDataGrid } from "../../../../../../common/components/styled_data_grid";
import { ControlePatrimonio } from "../../../../domain/models/controle_patrimonio";
import { GeneratePatrimonioColumnsDefinition } from "../columns";

import PrimaryButton from "../../../../../../common/components/primary_button";

/**
 * TabControlePatrimonioContent
 */

type Props = {
  loading: boolean,
  controlePatrimonios: ControlePatrimonio[],
  controlePatrimonioPage: number,
  controlePatrimonioRowsPerPage: number,
  controlePatrimonioTotalCount: number,
  onControlePatrimonioPageChange: (page: number) => void,
  onControlePatrimonioRowsPerPageChange: (rowsPerPage: number) => void,
  onCadastrarControlePatrimonio: (idControlePatrimonio: number | null, openState: boolean) => void,
  onEditarControlePatrimonio: (idControlePatrimonio: number | null, openState: boolean) => void,
  onDeletarControlePatrimonio: (idControlePatrimonio: number | null, openState: boolean) => void,
};

export const TabControlePatrimonioContent = ({
  loading,
  controlePatrimonios,
  controlePatrimonioPage,
  controlePatrimonioRowsPerPage,
  controlePatrimonioTotalCount,
  onControlePatrimonioPageChange,
  onControlePatrimonioRowsPerPageChange,
  onCadastrarControlePatrimonio,
  onEditarControlePatrimonio,
  onDeletarControlePatrimonio,
}: Props) => {
  const columnsDefinition = useMemo(() => {
    return GeneratePatrimonioColumnsDefinition({
      onEditar: (id) => onEditarControlePatrimonio(id, true),
      onDeletar: (id) => onDeletarControlePatrimonio(id, true),
    });
  }, [
    onEditarControlePatrimonio,
    onDeletarControlePatrimonio,
  ]);

  return (
    <>
      <>
        <div className="div flex mt-8 justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
          <div className="flex gap-2 items-center w-full">
            <h1 className="text-xl font-medium text-black dark:text-white">
              Controle de Patrimônio
            </h1>
          </div>

          <div className="flex justify-end flex gap-2">
            <PrimaryButton
              className="whitespace-nowrap"
              sx={{ paddingX: 3 }}
              onClick={() => onCadastrarControlePatrimonio(null, true)}>
              Cadastrar Controle de Patrimônio
            </PrimaryButton>
          </div>
        </div>
      </>

      <Stack spacing={0} className="mt-4">
        <TablePagination
          component="div"
          count={controlePatrimonioTotalCount}
          page={controlePatrimonioPage - 1}
          onPageChange={(_, p) => onControlePatrimonioPageChange(p)}
          rowsPerPageOptions={[10, 25, 50, 100]}
          rowsPerPage={controlePatrimonioRowsPerPage}
          onRowsPerPageChange={(e) => onControlePatrimonioRowsPerPageChange(parseInt(e.target.value))} />

        <StyledDataGrid
          tableName="tab_controle_patrimonio_content"
          disableColumnMenu={false}
          disableRowSelectionOnClick={true}
          getRowId={(row: ControlePatrimonio) => row.idControlePatrimonio}
          columns={columnsDefinition}
          loading={loading}
          rows={controlePatrimonios}
          rowCount={controlePatrimonios.length}
          pageSizeOptions={[10, 25, 50, 100]}
          paginationMode="server"
          paginationModel={{
            page: controlePatrimonioPage,
            pageSize: controlePatrimonioRowsPerPage,
          }} />

        <TablePagination
          component="div"
          count={controlePatrimonioTotalCount}
          page={controlePatrimonioPage - 1}
          onPageChange={(_, p) => onControlePatrimonioPageChange(p)}
          rowsPerPageOptions={[10, 25, 50, 100]}
          rowsPerPage={controlePatrimonioRowsPerPage}
          onRowsPerPageChange={(e) => onControlePatrimonioRowsPerPageChange(parseInt(e.target.value))} />

      </Stack>
    </>
  );
}